/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-21T16:05:42+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import autoPrefix from './../utilities/autoPrefix';
import transitions from './transitions';

class SlideInChild extends Component {
  componentDidMount() {
    const {
      direction,
    } = this.props;

    // prepare for inital pop
    const style = this._containerNode.style;
    style.opacity = '1';

    const x = direction === 'left' ?
            '100%' :
            direction === 'right' ? '-100%' : '0';
    const y = direction === 'up' ?
            '100%' :
            direction === 'down' ? '-100%' : '0';

    autoPrefix.set(style, 'transform', `translate(${x},${y})`);

    // do animate instantly after mount
    // it is a little slower than original animation (+5ms)
    setTimeout(function() {
      autoPrefix.set(style, 'transform', `translate(0, 0)`);
    }, 5);
  }

  componentDidUpdate(prevProps) {
    const style = this._containerNode.style;
    const {
      in: prevEnabled,
    } = prevProps;

    const {
      in: currentEnabled,
      getLeaveDirection,
      direction,
    } = this.props;

	    // will pop
    if (currentEnabled === true && prevEnabled !== currentEnabled) {
      style.opacity = '1';
      autoPrefix.set(style, 'transform', `translate(0, 0)`);
    }

    // will leave
    if (currentEnabled === false && prevEnabled !== currentEnabled) {
      const x = getLeaveDirection() === 'left' ? '-100%' :
                getLeaveDirection() === 'right' ? '100%' : '0';
      const y = getLeaveDirection() === 'up' ? '-100%' :
                getLeaveDirection() === 'down' ? '100%' : '0';

      style.opacity = '0';
      autoPrefix.set(style, 'transform', `translate(${x}, ${y})`);
    }
  }


  render() {
    const {
      children,
      getLeaveDirection, // eslint-disable-line no-unused-vars
      style,
      onExited,
      in: currentEnabled,
      ...other
    } = this.props;

    const mergedRootStyles = Object.assign({}, {
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: 0,
      left: 0,
      transition: transitions.easeOut(null, ['transform', 'opacity']),
    }, style);

    return (
      <div {...other} ref={this.refContainer} style={mergedRootStyles}>
        {children}
      </div>
    );
  }

    refContainer = (node) => {
      this._containerNode = node;
    }
}

SlideInChild.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.string,
  // This callback is needed bacause the direction could change when leaving the DOM
  getLeaveDirection: PropTypes.func.isRequired,
  style: PropTypes.object,
};

export default SlideInChild;

